module.exports = __webpack_public_path__ + "media/images/area/feature/setouchi/related/en/1-08c51a6f6215b92e31b9be7c13f1c77f.jpg";